import { PLAN_PRICES, PLAN_PRICE_IDS } from '@/constants/pricing'
import { useI18n } from '@/composables/useI18n'

const PRO_FEATURES = [
  'Transcrição de consultas via telemedicina ou presencial',
  'Customização de anamnese',
  'Upload e leitura de exames',
  'Consultas ilimitadas',
  'Sem limite de horas de transcrição',
]

export { PRO_FEATURES }

const formatBrl = (cents) =>
  new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(cents / 100)

export function usePlanCards() {
  const { t } = useI18n()

  const plans = computed(() => {
    return [
      {
        id: 1,
        name: t('pricingPlans.plans.semester.name'),
        currency: 'BRL',
        currencySymbol: 'R$',
        formattedPrice: PLAN_PRICES.SEMESTER / 100,
        billingPeriodText: t('pricingPlans.plans.semester.billingPeriod'),
        billingDescription: `R$${formatBrl(PLAN_PRICES.SEMESTER)} a cada 6 meses`,
        perMonthFormatted: '150,00',
        tag: null,
        priceId: PLAN_PRICE_IDS.SEMESTER,
        smallDescription: t('pricingPlans.plans.semester.description'),
        discount: null,
        features: PRO_FEATURES,
      },
      {
        id: 2,
        name: t('pricingPlans.plans.yearly.name'),
        currency: 'BRL',
        currencySymbol: 'R$',
        formattedPrice: PLAN_PRICES.YEARLY / 100,
        billingPeriodText: t('pricingPlans.plans.yearly.billingPeriod'),
        billingDescription: `R$${formatBrl(PLAN_PRICES.YEARLY)} por ano`,
        perMonthFormatted: '140,00',
        tag: 'Economize 7%',
        priceId: PLAN_PRICE_IDS.YEARLY,
        smallDescription: t('pricingPlans.plans.yearly.description'),
        discount: '-7%',
        features: PRO_FEATURES,
      },
    ]
  })

  return { plans }
}
